import React, { useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { NotebookContext } from '../context/NotebookContext';
import { UserContext } from '../context/UserContext';
import client from '../lib/client';
import { groupCreateOrUpdateMutation } from '../queries/groups';
import {
  GroupCreateOrUpdateMutation,
  GroupCreateOrUpdateMutationVariables
} from '../queries/__generated__/GroupCreateOrUpdateMutation';
import ErrorMessages from './ErrorMessages';
import { Input } from './forms';
import { Modal } from './ui';

interface NewGroupModalProps {
  closeModal: () => void;
}

const NewGroupModal: React.FC<NewGroupModalProps> = ({ closeModal }) => {
  const [groupName, setGroupName] = useState('');
  const [errors, setErrors] = useState<{ message: string }[]>([]);
  const { notebook, reloadNotebook } = useContext(NotebookContext);
  const { reloadUser } = useContext(UserContext);

  async function createGroup() {
    const res = await client.mutate<
      GroupCreateOrUpdateMutation,
      GroupCreateOrUpdateMutationVariables
    >({
      mutation: groupCreateOrUpdateMutation,
      variables: {
        input: {
          name: groupName,
          notebookId: notebook.id
        }
      }
    });

    const { group, errors } = res.data!.createOrUpdateGroup;
    if (errors) {
      setErrors(errors);
      return;
    }

    toast(`New group created: ${group!.name}`, { type: 'success' });
    reloadNotebook();
    reloadUser();
    closeModal();
  }

  return (
    <Modal closeModal={closeModal}>
      <div className="pa4 navy">
        <h1 className="f4 fw6 mb3 tc">New Group</h1>

        <div className="mb3 tc">
          <ErrorMessages errors={errors} />
        </div>

        <form
          onSubmit={e => {
            e.preventDefault();
            if (groupName) {
              createGroup();
            }
          }}
        >
          <Input
            value={groupName}
            onChange={e => setGroupName(e.target.value)}
            placeholder="Group name..."
            data-testid="group-name-input"
            autoFocus
          />
        </form>
      </div>

      <div className="flex bt b--light-gray navy">
        <button
          className="w-50 br b--light-gray f6 pa3 tc blue hover-navy"
          onClick={closeModal}
          data-testid="cancel-button"
        >
          Cancel
        </button>

        <button
          className="w-50 f6 pa3 tc blue hover-navy"
          onClick={createGroup}
          disabled={!groupName}
          data-testid="create-group-button"
        >
          Create Group
        </button>
      </div>
    </Modal>
  );
};

export default NewGroupModal;
